import { render, staticRenderFns } from "./KMIInterestComponent.vue?vue&type=template&id=88a96822"
import script from "./KMIInterestComponent.vue?vue&type=script&lang=ts"
export * from "./KMIInterestComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports